export const GET_COMMODITY_LIST = "GET_COMMODITY_LIST";
export const COMMODITY_LIST = "COMMODITY_LIST";

export const SEARCH_COMMODITY_BY_ID = "SEARCH_COMMODITY_BY_ID";
export const COMMODITY_BY_ID = "COMMODITY_BY_ID";

export const SEARCH_COMMODITY_BY_FIELD = "SEARCH_COMMODITY_BY_FIELD";
export const COMMODITY_BY_FIELD_LIST = "COMMODITY_BY_FIELD_LIST";

export const ADD_COMMODITY = "ADD_COMMODITY";
export const ADD_COMMODITY_RESP = "ADD_COMMODITY_RESP";

export const UPDATE_COMMODITY = "UPDATE_COMMODITY";
export const UPDATE_COMMODITY_RESP = "UPDATE_COMMODITY_RESP";

export const DELETE_COMMODITY = "DELETE_COMMODITY";
export const DELETE_COMMODITY_RESP = "DELETE_COMMODITY_RESP";

export const GET_COMMODITIES_LINKBY_CONTRACT_ID = "GET_COMMODITIES_LINKBY_CONTRACT_ID";
export const COMMODITIES_LINKBY_CONTRACT_ID_RESP = "COMMODITIES_LINKBY_CONTRACT_ID_RESP";

export const GET_COST_TRACKER_CONTRACTS_BY_COMMODITY_ID = "GET_COST_TRACKER_CONTRACTS_BY_COMMODITY_ID";
export const COST_TRACKER_CONTRACTS_BY_COMMODITY_ID_RESPONSE = "COST_TRACKER_CONTRACTS_BY_COMMODITY_ID_RESPONSE";
